import React from 'react';
import { SwiperOptions } from 'swiper';
import { IProps, IChildElement } from 'components/SliderBoundlessPcMobile/types';
import Slider from 'components/Slider';

const SliderBoundlessPcMobile: React.FC<IProps> & IChildElement = (props) => {
  const config: SwiperOptions = {
    loop: props.loopSetting,
    breakpoints: {
      0: {
        slidesPerView: 3,
        spaceBetween: 10
      }
    },
    centerInsufficientSlides: true
  };

  return (
    <div className="slider-boundless-pc-mobile">
      <Slider
        name={props.name}
        config={config}
      >
        {props.children}
      </Slider>
    </div>
  );
};

SliderBoundlessPcMobile.Item = Slider.Item;

export default SliderBoundlessPcMobile;
